define('app/filters/controls/FilterControls',['require','./AddFilterControl','./StringFilterControl','./NumericFilterControl','./BlankFilterControl','./BetweenFilterControl','./SelectFilterControl','./InFilterControl','./HasFilterControl','./RollingDateFilterControl','./DateFilterControl','./TimespanFilterControl','./BooleanFilterControl'],function(require) {
	'use strict';
	return {
		add: require('./AddFilterControl'),
		text: require('./StringFilterControl'),
		numeric: require('./NumericFilterControl'),
		empty: require('./BlankFilterControl'),
		between: require('./BetweenFilterControl'),
		select: require('./SelectFilterControl'),
		'in': require('./InFilterControl'),
		'has': require('./HasFilterControl'),
		rollingdate: require('./RollingDateFilterControl'),
		date: require('./DateFilterControl'),
		timespan: require('./TimespanFilterControl'),
		boolean: require('./BooleanFilterControl')
	};
});

